import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Appearance, useAppearance } from "@/hooks/use-appearance";
import { cn } from "@/lib/utils";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

const themes = [
  { value: "light" as Appearance, icon: Sun },
  { value: "dark" as Appearance, icon: Moon },
  { value: "system" as Appearance, icon: Monitor },
];

export default function AppearanceMenuIcons({ className = "" }) {
  const { appearance, updateAppearance } = useAppearance();
  const { t } = useTranslation("home_settings_appareance");

  const getTabTranslation = (value: string) => {
    switch (value) {
      case "light":
        return t("tabs.light");
      case "dark":
        return t("tabs.dark");
      case "system":
        return t("tabs.system");
      default:
        return value;
    }
  };

  return (
    <div className={cn("flex items-center justify-end gap-1", className)}>
      <TooltipProvider>
        {themes.map(({ value, icon: Icon }) => (
          <Tooltip key={value}>
            <TooltipTrigger asChild>
              <Button
                variant={appearance === value ? "secondary" : "ghost"}
                size="icon"
                className={cn("rounded-full", appearance === value && "ring-secondary ring-2")}
                onClick={() => updateAppearance(value)}
                aria-label={getTabTranslation(value)}
              >
                <Icon className="h-5 w-5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>{getTabTranslation(value)}</TooltipContent>
          </Tooltip>
        ))}
      </TooltipProvider>
    </div>
  );
}
